
import Airpods from "../../../assets/filled/Airpods.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function AirpodsIcon({ className, dataTestid = "AirpodsIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Airpods data-testid={dataTestid} className={classes} {...rest} />
  );
}
